import React from 'react';
import {  DateInput,Responsive,SimpleList,NumberField,DateField,Show,ShowButton,List, TextField, SimpleShowLayout,ReferenceInput,Filter,SelectInput,FunctionField } from 'admin-on-rest/lib/mui';

import Datagrid from './Datagrid';
const dateFormatter = v => {
  // v is a string of "YYYY-MM-DD" format
  const match = /(\d{4})-(\d{2})-(\d{2})/.exec(v);
  if (match === null) return;
  const d = new Date(match[1], parseInt(match[2])-1, match[3]);
  if (isNaN(d)) return;
  return d;
};

const dateParser = v => {
  // v is a `Date` object
  if (!(v instanceof Date) || isNaN(v)) return;
  const pad = '00';
  const yy = v.getFullYear().toString();
  const mm = ((v.getMonth() + 1).toString());
  const dd = v.getDate().toString();
  return `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`;
};

var minDate=new Date();
minDate.setDate(minDate.getDate()-180);

const ZikuyimFilter = (props) => (
    
    <Filter {...props} >
         <ReferenceInput label="בית עסק" source="id" reference="customers" perPage={500} sort={{ field: 'name_heb', order: 'ASC' }} allowEmpty>
            <SelectInput optionText="name_heb" />
        </ReferenceInput>
        <DateInput  format={dateFormatter} parse={dateParser} locales="he-IL" label="ת.סיום" source="EndDate" options={{
    mode: 'landscape',
   // maxDate: new Date(),
  //minDate:minDate,
    okLabel: 'אישור',
    
    cancelLabel: 'ביטול',
    locale: 'he'
}}/>
      <DateInput  format={dateFormatter} parse={dateParser} locales="he-IL" label="ת.התחלה" source="StartDate" options={{
    mode: 'landscape',
    //maxDate: new Date(),
  //minDate:minDate,
    okLabel: 'אישור',
    
    cancelLabel: 'ביטול',
    locale: 'he'
}}/>
        
    
    </Filter>
);


const rowStyle = (record) => {
    if (record.commission_ammount <0) return { backgroundColor: '#fdd' };
    
    return {};
};


export const ZikuyimList1 = (props) => (
    <div>
    <List title="דף חשבון" perPage={30} {...props}  filters={<ZikuyimFilter /> }>
     
      <Responsive
       small={
        
                 <Datagrid  rowStyle={rowStyle} bodyOptions={{showRowHover: true }}>
            
<TextField label="#" source="id" />

<DateField label="תאריך הפקדה" source="hafkada_date.date" locales="he-IL"/>
<DateField label="תאריך עסקה" source="iska_date.date" locales="he-IL"/>
<DateField label="תאריך זיכוי" source="zikui_date.date" locales="he-IL" />
<TextField label="סוג עסקה" source="tnuaa_type" />


<NumberField label="סכום עסקה" source="schum_iska" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />
<NumberField label="סכום ברוטו לזיכוי" locales="he-IL" source="zikui_total_bruto" options={{ style: 'currency', currency: 'ILS' }}/>

<NumberField label="עמלה" style={{overflow:'visible '}} source="commission_ammount" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }}/>
<NumberField label="עמלה + מעמ"  style={{overflow:'visible '}} source="commission_ammount_vat" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />
<NumberField label="סכום נטו לזיכוי" style={{overflow:'visible '}} source="neto_zicui" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }}/>

<TextField label="מספר ריכוז" source="rikuz_number" />
<TextField label="כ.א 4 ספרות" source="cc_id" />

    

    
            <ShowButton />
        </Datagrid>
            }
 medium={

            
    
            
        
          <Datagrid  rowStyle={rowStyle} bodyOptions={{showRowHover: true }}>
            
<TextField label="#" source="id" />

<DateField label="תאריך הפקדה" source="hafkada_date.date" locales="he-IL"/>
<DateField label="תאריך עסקה" source="iska_date.date" locales="he-IL"/>
<DateField label="תאריך זיכוי" source="zikui_date.date" locales="he-IL" />
<TextField label="סוג עסקה" source="tnuaa_type" />


<NumberField label="סכום עסקה" source="schum_iska" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />
<NumberField label="סכום ברוטו לזיכוי" locales="he-IL" source="zikui_total_bruto" options={{ style: 'currency', currency: 'ILS' }}/>

<NumberField label="עמלה" style={{overflow:'visible '}} source="commission_ammount" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }}/>
<NumberField label="עמלה + מעמ"  style={{overflow:'visible '}} source="commission_ammount_vat" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />
<NumberField label="סכום נטו לזיכוי" style={{overflow:'visible '}} source="neto_zicui" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }}/>

<TextField label="מספר ריכוז" source="rikuz_number" />
<TextField label="כ.א 4 ספרות" source="cc_id" />

    
 
    
            <ShowButton />
        </Datagrid>
        
        
 }
         />
  
    </List>
  
    </div>
);


const ZikuyimTitle = ({ record }) => {
    return <span>מספר {record ? `"${record.id}"` : ''}</span>;
};

const ZikuyimListTitle = ({ lst }) => {
    return <span>דף חשבון</span>;
};


export const ZikuyimList = props => (
    <List title="דף חשבון - זיכויים" perPage={30} {...props}  filters={<ZikuyimFilter /> }>
        <Datagrid  rowStyle={rowStyle} bodyOptions={{showRowHover: true }} totalRows="300">
            
<TextField label="#" source="id" />

<DateField label="תאריך הפקדה" source="hafkada_date.date" locales="he-IL"/>
<DateField label="תאריך העברה לבנק" source="bank_haavara_date.date" locales="he-IL"/>
<DateField label="תאריך עסקה" source="iska_date.date" locales="he-IL"/>
<DateField label="תאריך זיכוי" source="zikui_date.date" locales="he-IL" />
<TextField label="סוג עסקה" source="tnuaa_type"  />

<FunctionField label="סכום עסקה" source="schum_iska" render={record =>record.schum_iska.toLocaleString(undefined, {
                        style: 'currency',
                        currency: record.currency,
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })}/>
<NumberField label="סכום ברוטו לזיכוי" locales="he-IL" source="zikui_total_bruto" options={{ style: 'currency', currency: 'ILS' }}/>

<NumberField label="עמלה" style={{overflow:'visible '}} source="commission_ammount" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }}/>
<NumberField label="עמלה + מעמ"  style={{overflow:'visible '}} source="commission_ammount_vat" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />
<NumberField label="סכום נטו לזיכוי" style={{overflow:'visible '}} source="neto_zicui" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }}/>

<TextField label="מספר ריכוז" source="rikuz_number" />
<TextField label="כ.א 4 ספרות" source="cc_id" />

    
 
    
            <ShowButton />
        </Datagrid>
        
    </List>
);





const ZikuyimStyle = {
  width:120,
    minHeight: 40,
    marginLeft: '2em',
    display: 'inline-block',
    verticalAlign: 'top'
};



export const ZikuyimShow = (props) => (

<Show title={<ZikuyimTitle />} {...props}>
 <SimpleShowLayout >
  <TextField style={ZikuyimStyle}  label="#" source="id" />
<TextField style={ZikuyimStyle}  label="מזהה רשת חיצוני" source="external_id" />

<TextField style={ZikuyimStyle} label="מספר בית עסק" source="buisiness_id" />
<TextField style={ZikuyimStyle} label="מספר כרטיס מלא" source="cc_id" />

<TextField style={ZikuyimStyle}  elStyle={{ width: '5em' }} label="מספר שובר" source="shovar_number" />
<TextField style={ZikuyimStyle} label="סוג תנועה" source="tnuaa_type" />
<TextField style={ZikuyimStyle} label="מקור  תנועה" source="tnuaa_source" />
<DateField style={ZikuyimStyle} label="תאריך הפקדה" source="hafkada_date.date" />
<DateField style={ZikuyimStyle} label="תאריך העברה לבנק" source="bank_haavara_date.date" />


<DateField style={ZikuyimStyle} label="תאריך זיכוי" source="zikui_date.date" />
<TextField style={ZikuyimStyle} label="מספר חשבון" source="account_number" />
<TextField style={ZikuyimStyle} label="מטבע תנועה" source="tnuaa_currency" />
<TextField style={ZikuyimStyle} label="מטבע זיכוי" source="zikui_currency" />
<TextField style={ZikuyimStyle} label="אינדיקציה לתשלומים" source="payments_indication" />
<TextField style={ZikuyimStyle} label="סכום עסקה  ברוטו תשלומים" source="bruto_iska_tashlumim" />
<TextField style={ZikuyimStyle} label="סכום ברוטו לזיכוי " source="zikui_total_bruto" />
<TextField style={ZikuyimStyle} label="סכום עמלה" source="commission_ammount" />
<TextField style={ZikuyimStyle} label="מעמ עמלה" source="comission_vat" />
<TextField style={ZikuyimStyle} label="סכום ההנחה" source="discount_ammount" />
<TextField style={ZikuyimStyle} label="סכום זיכוי" source="total_zikui" />
<TextField style={ZikuyimStyle} label="מספר תשלום נוכחי" source="current_payment_number" />
<TextField style={ZikuyimStyle} label="מספר תשלומים" source="total_payments" />
<TextField style={ZikuyimStyle} label="יתרת תשלומים" source="remaining_payments" />
<TextField style={ZikuyimStyle} label="סכום ריבית דמי ניכיון" source="total_dme_nikayon_interest" />
<TextField style={ZikuyimStyle} label="סכום דמי ניהול " source="total_dme_nihul" />
<TextField style={ZikuyimStyle} label="ניקוד ב- pos" source="pos_points" />

<TextField style={ZikuyimStyle} label="מספר מסוף" source="masof_number" />
<TextField style={ZikuyimStyle} label="תש' ראשון" source="first_payment" />
<TextField style={ZikuyimStyle} label="סכום תשלום" source="total_ammount" />
<TextField style={ZikuyimStyle} label="מועדון" source="club" />

<TextField style={ZikuyimStyle} label="קוד אישור" source="kod_ishur" />
<TextField style={ZikuyimStyle} label="קוד מאפיין  עסקה" source="kod_meafyen_iska" />
<TextField style={ZikuyimStyle} label="קוד אופי עסקה" source="kod_ofi_iska" />
<TextField style={ZikuyimStyle} label="מזהה חד ערכי" source="unique_id" />
<TextField style={ZikuyimStyle} label="סכום ביטול" source="bitul_ammount" />
<TextField style={ZikuyimStyle} label="סכום עצירה" source="stop_ammount" />
<TextField style={ZikuyimStyle} label="מזהה תנועה" source="tnuaa_id" />
<TextField style={ZikuyimStyle} label="מהות עסקה" source="mahut_iska" />
<TextField style={ZikuyimStyle} label="שער המרה" source="shaar_hamara" />
<TextField style={ZikuyimStyle} label="שדה Z" source="z_field" />
<TextField style={ZikuyimStyle} label="מזדמנת כ/ל" source="mizdamenet" />
<TextField style={ZikuyimStyle} label="סטטוס רשומה 1/2" source="status_reshuma" />
<TextField style={ZikuyimStyle} label="שם בית עסק" source="shem_esek" />
<TextField style={ZikuyimStyle} label="מספר חשבון" source="mispar_cheshbon" />
<TextField style={ZikuyimStyle} label="מזהה תוכנית כאל לקבל יותר" source="mezahe_tochnit_cal_yoter" />
<TextField style={ZikuyimStyle} label="סכום הנחת כאל לקבל יותר" source="hanacha_cal_yoter" />
<TextField style={ZikuyimStyle} label="אחוז הנחת כאל לקבל יותר" source="ahuz_hanacha_cal_yoter" />
<TextField style={ZikuyimStyle} label="Mid Trn ID" source="mid_trn_id" />
<TextField style={ZikuyimStyle} label="PSP Trn ID" source="psp_trn_id" />
<TextField style={ZikuyimStyle} label="Gateway Trn ID" source="gateway_trn_id" />
<TextField style={ZikuyimStyle} label="מזהה בקשת אישור" source="mezahe_bakasha_ishur" />

<TextField style={ZikuyimStyle} label="מספר חשבונית" source="mispar_cheshbonit" />
<TextField style={ZikuyimStyle} label="מספר משלם" source="mispar_meshalem" />
<TextField style={ZikuyimStyle} label="סוג תנועה שבא" source="sug_tnuaa_shva" />
<TextField style={ZikuyimStyle} label="סכום מזומן CASHBACK" source="mezuman_schum_cashback" />
<TextField style={ZikuyimStyle} label="מזהה עסקה שבא" source="mezahe_iska_shva" />
<TextField style={ZikuyimStyle} label="אינדיקציה לתייר" source="tayar_indikazia" />
<TextField style={ZikuyimStyle} label="קובץ מקור" source="source_file" />

         </SimpleShowLayout>
    </Show>
);






























// WEBPACK FOOTER //
// ./src/components/Zikuyim/zikuyim.js